import {Utility} from './utils';

if (Utility.isProd) {
  (function (d, t) {
    const BASE_URL = 'https://app.limechat.ai';
    const g = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
    g.src =
      'https://s3.ap-south-1.amazonaws.com/cdn.limechat.ai/packs/js/LC_sdk/v1/sdk.js';
    g.defer = true;
    s.parentNode.insertBefore(g, s);
    g.onload = function () {
      window.chatwootSDK.run({
        websiteToken: 'h8TmMeaaZ8zz5J8PQdHnfbiY',
        baseUrl: BASE_URL,
      });
    };
  })(document, 'script');

  const url =
    'https://s3.ap-south-1.amazonaws.com/cdn.limechat.ai/packs/js/whatsapp_widget/LC_whatsapp_widget.js';
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.defer = true;
  s.src = url;
  s.onload = function () {
    // eslint-disable-next-line no-undef
    const whatsAppBtn = new LimeChatWhatsapp({
      phone: '919289639203',
      prefill_text: 'Hey, Let’s chat about DU Digital.',
      button_message_mobile: 'Chat with us',
      button_message_desktop: 'Chat with us',
      display_on: 'both',
      widget_type_desktop: 'icon',
      widget_type_mobile: 'icon',
      display_size_desktop: 50,
      position_desktop: 'right',
      bottom_margin_desktop: 96,
      left_margin_desktop: 48,
      right_margin_desktop: 16,
      display_size_mobile: 50,
      position_mobile: 'right',
      bottom_margin_mobile: 96,
      left_margin_mobile: 24,
      right_margin_mobile: 16,
      show_pop_up: true,
      pop_up_message_position: 'side',
      pop_up_message_text: "Hey, Let's chat!",
      pop_up_image: ' ',
      pop_up_delay: 3,
      pdp_prefill_text: 'Hey! I would like to know about ',
      pages_to_display: [
        'homepage',
        'cart',
        'blogs',
        'products',
        'collections',
        'checkout',
        'pages',
      ],
      includeVariant: false,
      isShopify: false,
      zIndex: 100000,
    });
    whatsAppBtn.renderButton();
  };
  var x = document.getElementsByTagName('script')[0];
  x.parentNode.insertBefore(s, x);
}
